import {
  arrayBufferDownload,
  arrayBufferDownloadExcel,
  downloadCSV,
} from "../../../../utils/download";
import {
  decorateEmptyGridValues,
  setColumnDefaultExtraProps,
} from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_SETTINGS_PAYNOWDISCOUNTS_LIST,
  TOAST,
  FETCH_SETTINGS_PAYNOWDISCOUNTS_INIT,
  FETCH_SETTINGS_PAYNOWDISCOUNTS_DETAIL,
  EXPORT_SETTINGS_PAYNOWDISCOUNTS,
  CREATE_SETTINGS_PAYNOWDISCOUNTS,
  EDIT_SETTINGS_PAYNOWDISCOUNTS,
  INIT_CREATE_SETTINGS_PAYNOWDISCOUNTS_SCREEN,
  SETTINGS_PAYNOWDISCOUNTSDD,
  SETTINGS_PAYNOWDISCOUNTSDELETE,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  SETTINGS_PAYNOWDISCOUNTS_SAVE_TABLE_STATE,
} from "../../../types/Settings/PaynowDiscounts.type";
import { formatDatesMmDdYyyy } from "../../../../utils";

const formFieldValueMap = {
  id: null,
  amount: "",
  modBy: "",
  modTime: "",
  status: 1,
  endDate: "",
  startDate: "",
  type: "",
  userId: "",
};

const INITIAL_STATE = {
  SettingsPaynowDiscountsListview: [],
  RateCodeDD: [],
  isSettingsPaynowDiscountsDDSuccess: false,
  isSettingsPaynowDiscountsDDError: false,
  isLoading: false,
  error: null,
  formFieldValueMap,
  isSettingsPaynowDiscountsCreateSuccess: false,
  isSettingsPaynowDiscountsCreateError: false,
  isSettingsPaynowDiscountsDetailSuccess: false,
  isSettingsPaynowDiscountsDetailError: false,
  isSettingsPaynowDiscountsEditSuccess: false,
  isSettingsPaynowDiscountsEditError: false,
  isSettingsPaynowDiscountsExportSuccess: false,
  isSettingsPaynowDiscountsExportError: false,
  isUploadImageSuccess: false,
  isUploadImageError: false,
  imageUploadResponse: null,
  isSettingsPaynowDiscountsDeleteSuccess: false,
  isSettingsPaynowDiscountsDeleteError: false,
  savedTableState: null,
};

const tranformToGridView = (data) => {
  const rows = data.map((item) => {
    const {
      crtBy,
      crtTime,
      startDate,
      endDate,
      type,
      amount,
      id,
      modBy,
      modTime,
      status,
    } = item;

    const transformedValues = {
      crtBy,
      crtTime,
      startDate,
      endDate,
      type,
      amount,
      id,
      modBy,
      modTime,
      status,
    };
    const decoratedValues = {};
    Object.keys(transformedValues).forEach((key) => {
      decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
    });
    return decoratedValues;
  });

  const columns = [
    {
      colLabel: "ID",
      dataKey: "id",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: false,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Start Date",
      dataKey: "startDate",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "End Date",
      dataKey: "endDate",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Type",
      dataKey: "type",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Amount",
      dataKey: "amount",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Crt By",
      dataKey: "crtBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Crt Time",
      dataKey: "crtTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Mod By",
      dataKey: "modBy",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Edit Time",
      dataKey: "modTime",
      extraProps: {
        isSortable: true,
        isDateField: true,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
    {
      colLabel: "Status",
      dataKey: "status",
      extraProps: {
        isSortable: true,
        isDateField: false,
        shouldFilter: true,
        hidden: false,
        showFilterMenu: false,
        filterPlaceholder: "Search...",
      },
    },
  ];

  return {
    datas: { columns, rows },
  };
};

export const SettingsPaynowDiscountsReducer = (
  state = INITIAL_STATE,
  action
) => {
  switch (action.type) {
    case FETCH_SETTINGS_PAYNOWDISCOUNTS_INIT:
      return { ...INITIAL_STATE, savedTableState: state.savedTableState, isLoadingPage: true };
    case FETCH_SETTINGS_PAYNOWDISCOUNTS_DETAIL.START:
    case EXPORT_SETTINGS_PAYNOWDISCOUNTS.START:
    case UPLOAD_IMAGE.START:
    case FETCH_SETTINGS_PAYNOWDISCOUNTS_LIST.START:
    case CREATE_SETTINGS_PAYNOWDISCOUNTS.START:
    case SETTINGS_PAYNOWDISCOUNTSDELETE.START:
    case EDIT_SETTINGS_PAYNOWDISCOUNTS.START:
    case SETTINGS_PAYNOWDISCOUNTSDD.START:
      return { ...state, isLoading: true };

    case FETCH_SETTINGS_PAYNOWDISCOUNTS_LIST.SUCCESS: {
      const { page, data } = action.payload;

      let resetState = {
        SettingsPaynowDiscountsListview: [],
        paginationInfo: null,
        error: null,
        isLoading: false,
        isLoadingPage: false,
        isPageLevelError: false,
        isSettingsPaynowDiscountsCreateSuccess: false,
        isSettingsPaynowDiscountsCreateError: false,
        savedTableState: state.savedTableState,
      };
      if (!data) {
        return resetState;
      }
      const { number, size, totalElements, totalPages } = page;
      const { datas } = tranformToGridView(data);
      return {
        ...resetState,
        SettingsPaynowDiscountsListview: datas,
        paginationInfo: {
          pageSize: size,
          totalRecords: totalElements,
          totalPages: totalPages,
          pageNumber: number,
        },
      };
    }
    case FETCH_SETTINGS_PAYNOWDISCOUNTS_LIST.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        SettingsPaynowDiscountsListview: [],
        isLoading: false,
        isLoadingPage: false,
        error,
        isPageLevelError: true,
        isSettingsPaynowDiscountsDeletionSuccess: false,
        isSettingsPaynowDiscountsDeletionError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }

    case FETCH_SETTINGS_PAYNOWDISCOUNTS_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
            temp[key] = action.payload[key];
            if (key === "endDate") {
              temp[key] = formatDatesMmDdYyyy(action.payload[key]);
            }
            if (key === "startDate") {
              temp[key] = formatDatesMmDdYyyy(action.payload[key]);
            }
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isSettingsPaynowDiscountsDetailSuccess: true,
      };
    }
    case FETCH_SETTINGS_PAYNOWDISCOUNTS_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isSettingsPaynowDiscountsDetailSuccess: false,
        isSettingsPaynowDiscountsDetailError: true,
      };
    }

    //DD
    case SETTINGS_PAYNOWDISCOUNTSDD.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        RateCodeDD: temp,
        isSettingsPaynowDiscountsDDSuccess: true,
        isSettingsPaynowDiscountsDDError: false,
      };
    }
    case SETTINGS_PAYNOWDISCOUNTSDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isSettingsPaynowDiscountsDDSuccess: false,
        isSettingsPaynowDiscountsDDError: true,
      };
    }
    //END DD
    //DELETE

    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY: {
      const shouldOpenDeleteConfirmationPopup = action.payload;
      return {
        ...state,
        shouldOpenDeleteConfirmationPopup,
        isSettingsPaynowDiscountsDeleteSuccess: false,
        isSettingsPaynowDiscountsDeleteError: false,
      };
    }
    case SETTINGS_PAYNOWDISCOUNTSDELETE.SUCCESS: {
      const temp = action.payload;

      return {
        ...state,
        isLoading: false,
        isSettingsPaynowDiscountsDeleteSuccess: true,
        isSettingsPaynowDiscountsDeleteError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    case SETTINGS_PAYNOWDISCOUNTSDELETE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isLoading: false,
        isSettingsPaynowDiscountsDeleteSuccess: false,
        isSettingsPaynowDiscountsDeleteError: true,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    //END DD

    // UPLOAD_IMAGE Start
    case UPLOAD_IMAGE.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isUploadImageSuccess: false,
        isUploadImageError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case UPLOAD_IMAGE.SUCCESS: {
      const { data } = action.payload;
      return {
        ...state,
        imageUploadResponse: data,
        isUploadImageSuccess: true,
        isUploadImageError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // UPLOAD_IMAGE End

    // Export Start
    case EXPORT_SETTINGS_PAYNOWDISCOUNTS.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        isLoading: false,
        isLoadingPage: false,
        error,
        isSettingsPaynowDiscountsExportSuccess: false,
        isSettingsPaynowDiscountsExportError: true,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    case EXPORT_SETTINGS_PAYNOWDISCOUNTS.SUCCESS: {
      const data = action.payload;
      arrayBufferDownloadExcel(data, "paynow-discounts.xls");
      return {
        ...state,
        isSettingsPaynowDiscountsExportSuccess: true,
        isSettingsPaynowDiscountsExportError: false,
        shouldOpenExportConfirmationPopup: false,
      };
    }

    // Export End

    // EDIT
    case EDIT_SETTINGS_PAYNOWDISCOUNTS.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isSettingsPaynowDiscountsEditSuccess: false,
        isSettingsPaynowDiscountsEditError: true,
      };
    }

    case EDIT_SETTINGS_PAYNOWDISCOUNTS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isSettingsPaynowDiscountsEditSuccess: true,
        isSettingsPaynowDiscountsEditError: false,
      };
    }

    // EDIT END

    // Create
    case INIT_CREATE_SETTINGS_PAYNOWDISCOUNTS_SCREEN: {
      return { ...INITIAL_STATE, savedTableState: state.savedTableState };
    }

    case CREATE_SETTINGS_PAYNOWDISCOUNTS.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isSettingsPaynowDiscountsCreateSuccess: false,
        isSettingsPaynowDiscountsCreateError: true,
      };
    }
    case CREATE_SETTINGS_PAYNOWDISCOUNTS.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isSettingsPaynowDiscountsCreateSuccess: true,
        isSettingsPaynowDiscountsCreateError: false,
      };
    }

    //End

    case TOAST.RESET: {
      return {
        ...state,
        isSettingsPaynowDiscountsCreateSuccess: false,
        isSettingsPaynowDiscountsCreateError: false,
        isSettingsPaynowDiscountsEditError: false,
        isSettingsPaynowDiscountsEditSuccess: false,
        isSettingsPaynowDiscountsDetailError: false,
      };
    }
    case SETTINGS_PAYNOWDISCOUNTS_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }
    default:
      return state;
  }
};
